<ng-container *ngFor="let key of requestOutcomeKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="
      normalizeLog(key, log) | changeLogsDiffHTML : requestOutcomeLookup : requestOutcomeKeyWithLookup[key] ?? null
    "
  ></div>
</ng-container>
